import type { AxiosInstance } from 'axios';
import type { AxiosResponse } from 'axios';
import type {
  Asset,
  AssetListResponse,
  EntityId,
} from '@/types';

export const getInspectionAsset = async (
  api: AxiosInstance,
  inspection_id: EntityId,
  asset_id: EntityId,
): Promise<Asset> => {
  const resp = await api.get<Asset>(`/inspection/${inspection_id}/asset/${asset_id}`);
  return resp.data;
};

export const getInspectionAssetBinary = async (
  api: AxiosInstance,
  inspection_id: EntityId,
  asset_id: EntityId,
): Promise<AxiosResponse<Blob>> => {
  const resp = await api.get<Blob>(`/inspection/${inspection_id}/asset/${asset_id}`, {
    responseType: 'blob',
  });
  return resp;
};

export const getInspectionAssets = async (
  api: AxiosInstance,
  inspection_id: EntityId,
): Promise<AssetListResponse> => {
  const resp = await api.get<AssetListResponse>(`/inspection/${inspection_id}/asset`);
  return resp.data;
};

